<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-new-observation" scrollable centered button-size="sm">
      <template #modal-title>
        <i class="fas fas fa-user"></i> NOVA OBSERVAÇÃO
      </template>

      <div class="form-group row">
        <div class="col-md-12">
          <b-form-textarea id="txtDetalhes"
                      name="txtDetalhes"
                      v-model="form.detalhes.value"
                      :placeholder="'Digite as observações aqui'"
                      :rows="form.detalhes.rows"
                      :size="form.detalhes.maxlength"
                      :noResize="form.detalhes.noResize"></b-form-textarea>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm rounded"
            v-on:click="onSave"
            v-b-tooltip.hover
            :title="$lang.Common.Tooltip.ButtonSave"
            >
            <i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Save}}</span>
          </button>&nbsp;        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

import CrmDetailsObservation from './observation.js'
export default CrmDetailsObservation

</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/observation/new/observation.vue